import { Suspense } from "react";
import { useLocation } from "react-router-dom";
import { HomeSkeletonFallback } from "./Skeleton/HomeSkeletonFallback";
import { SkeletonFallback } from "./Skeleton/SkeletonFallback";

const RouteAwareSuspense: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const getFallback = () => {
    if (location.pathname.startsWith("/fusion-analyzer")) {
      return null;
    }

    if (location.pathname === "/") {
      return <HomeSkeletonFallback />;
    }

    return <SkeletonFallback />;
  };

  return (
    <Suspense fallback={getFallback()}>
      {children}
    </Suspense>
  );
};


export default RouteAwareSuspense;